const INDIAN_DIAL_CODE = "+91";

export const INDIAN_PHONE_DIGITS = 10;

export function normalizeIndianPhone(value: string) {
	const digits = value.replace(/\D/g, "");

	if (/^91[6-9]\d{9}$/.test(digits)) {
		return `+${digits}`;
	}

	if (/^[6-9]\d{9}$/.test(digits)) {
		return `${INDIAN_DIAL_CODE}${digits}`;
	}

	return null;
}

export function sanitizeIndianPhoneInput(value: string) {
	const digits = value.replace(/\D/g, "");
	const withoutCountryCode = digits.startsWith("91") ? digits.slice(2) : digits;

	return withoutCountryCode.slice(0, INDIAN_PHONE_DIGITS);
}
